import { FC, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import icon1 from "../../../assets/icon/icon1.png";
import icon2 from "../../../assets/icon/icon2.png";
import defaultAvatar from "../../../assets/images/default-avatar.png";
import { getRatingAPI } from "../../../redux/sagas/userProgress.saga";
import { ISprintReport } from "@hero/shared/models/sprintReport";
import { UserProgress } from "@hero/shared/models/userProgress";
import { roleForPoint } from "@hero/shared/utils";
import { getColoWithPercent } from "../../../utils";
import LoadingWidget from "../../LoadingWidget";
import DisciplineWidget, { DetailDiscipline } from "./DisciplineWidget";
import RatingItem from "./RatingItem";

const VIOLATION_LABELS: Record<string, string> = {
    stale: "Không cập nhật >48h",
    todo_idle: "TODO Idle",
    overdue: "Quá hạn",
    escalation: "Leo thang",
    wip: "Quá nhiều task IP",
    no_estimate: "Chưa estimate",
    returned: "Bị trả lại",
    deadline_50: "Deadline 50%",
    deadline_66: "Deadline 66%",
    deadline_late_same_day: "Muộn trong ngày",
};

const ViolationDetail: FC<{ data: any }> = ({ data }) => {
    if (!data || !data.tasks || data.tasks.length === 0) {
        return (
            <div style={{ padding: "10px 0", color: "#4caf50" }}>
                Không có vi phạm quy trình
            </div>
        );
    }
    return (
        <div style={{ padding: "10px 0" }}>
            <h6 style={{ marginBottom: 8 }}>Vi phạm quy trình ({data.activeTotal || 0} đang vi phạm / {data.total || 0} tổng)</h6>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
                {Object.entries(data.types as Record<string, number>).map(([type, count]) => (
                    <span key={type} style={{
                        padding: "2px 8px", borderRadius: 10, fontSize: 12, color: "#fff",
                        background: type === "overdue" || type === "escalation" ? "#f44336" : "#ff9800",
                    }}>
                        {VIOLATION_LABELS[type] || type}: {count}
                    </span>
                ))}
            </div>
            {data.tasks.map((task: any, i: number) => (
                <div key={i} style={{
                    display: "flex", alignItems: "center", gap: 8,
                    padding: "6px 10px", marginBottom: 4, borderRadius: 6,
                    background: task.isCompleted ? "rgba(76,175,80,0.1)" : "rgba(244,67,54,0.08)",
                    opacity: task.isCompleted ? 0.5 : 1,
                }}>
                    <a
                        href={`/task/${task.taskId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#4fc3f7", fontWeight: 600, minWidth: 90, textDecoration: "none" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {task.shortId}
                    </a>
                    <span style={{ flex: 1, fontSize: 13 }}>{task.title}</span>
                    <span style={{ display: "flex", gap: 4 }}>
                        {task.violations?.map((v: any, j: number) => (
                            <span key={j} style={{
                                padding: "1px 6px", borderRadius: 8, fontSize: 10,
                                background: "rgba(255,152,0,0.2)", color: "#ff9800",
                            }}>
                                {VIOLATION_LABELS[v.type] || v.type} x{v.count}
                            </span>
                        ))}
                    </span>
                    {task.isCompleted && (
                        <span style={{ fontSize: 10, padding: "1px 6px", borderRadius: 8, background: "#4caf50", color: "#fff" }}>
                            Hoàn thành
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
};

const ShowUserDetails: FC<{
    item: any;
    detailDiscipline: DetailDiscipline;
    onHide: () => void;
}> = ({ item, onHide, detailDiscipline }) => {
    const avatar = item.user?.avatar ?? defaultAvatar;
    const [userProgress, setUserProgress] = useState<UserProgress[] | null>(null);
    useEffect(() => {
        getRatingAPI(item.userId, item.sprint).then((data) => {
            setUserProgress(data);
        });
    }, [item]);
    return (
        <Modal show={true} size="xl" centered onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <img src={avatar} width={35} height={35} style={{ borderRadius: 35 }} />
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <span>{item.user?.firstName + " " + item.user?.lastName}</span>
                </Modal.Title>
            </Modal.Header>
            <ModalBody>
                {!userProgress ? (
                    <LoadingWidget />
                ) : (
                    <div className="user-progress-content">
                        <RatingItem
                            title="Chất lượng công việc (số bugs trên tổng số task)"
                            color={getColoWithPercent(1 - item.bugTasks.length / item.totalTasks.length)}
                            value={item.bugTasks.length}
                            total={item.totalTasks.length}
                            icon={icon1}
                        />
                        <RatingItem
                            title="Tỷ lệ hoàn thành (số task hoàn thành)"
                            color={getColoWithPercent(item.finishedTasks.length / item.totalTasks.length)}
                            value={item.finishedTasks.length}
                            total={item.totalTasks.length}
                            icon={icon2}
                        />
                        {roleForPoint(item.user) && <DisciplineWidget detailDiscipline={detailDiscipline} />}
                        <ViolationDetail data={item._violations} />
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ShowUserDetails;
